module.exports = __webpack_public_path__ + "img/screen-shot.d9e1cbf4.jpg";